import React, { useState } from 'react';
import { Plus, Search, Building2, Euro, Calendar, Target, User, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const mockEsigenze = [{
  id: 1,
  company: 'Luxury Fashion Brand',
  companyCategory: 'Fashion',
  esigenza: 'Boutique in zona Montenapoleone',
  dettagli: '100-120 m², piano terra, vetrine ampie',
  budget: '800k-1M',
  dataRichiesta: '10/01/2024',
  soluzioneProposta: 'Via Montenapoleone 12',
  statoTrattativa: 'Trattativa',
  priorita: 'Alta',
  assignedTo: 'Mario Rossi',
  dealId: 1
}, {
  id: 2,
  company: 'Luxury Fashion Brand',
  companyCategory: 'Fashion',
  esigenza: 'Retail Via della Spiga',
  dettagli: '80-100 m², possibilità mezzanino',
  budget: '600k-800k',
  dataRichiesta: '08/01/2024',
  soluzioneProposta: 'Via della Spiga 8',
  statoTrattativa: 'Proposta',
  priorita: 'Alta',
  assignedTo: 'Mario Rossi',
  dealId: 2
}, {
  id: 3,
  company: 'Luxury Fashion Brand',
  companyCategory: 'Fashion',
  esigenza: 'Showroom zona Brera',
  dettagli: '150-200 m², spazi espositivi',
  budget: '700k-900k',
  dataRichiesta: '05/12/2023',
  soluzioneProposta: 'Corso Venezia 45',
  statoTrattativa: 'Chiusa',
  priorita: 'Media',
  assignedTo: 'Laura Bianchi',
  dealId: 3
}, {
  id: 4,
  company: 'Luxury Fashion Brand',
  companyCategory: 'Fashion',
  esigenza: 'Boutique Corso Como',
  dettagli: '90-110 m², zona pedonale',
  budget: '650k-850k',
  dataRichiesta: '20/12/2023',
  soluzioneProposta: '-',
  statoTrattativa: 'In Ricerca',
  priorita: 'Media',
  assignedTo: 'Giuseppe Verdi',
  dealId: null
}, {
  id: 5,
  company: 'Premium Lifestyle Co.',
  companyCategory: 'Lifestyle',
  esigenza: 'Flagship Store Quadrilatero',
  dettagli: '200-250 m², due piani, alta visibilità',
  budget: '1.2M-1.5M',
  dataRichiesta: '15/01/2024',
  soluzioneProposta: '-',
  statoTrattativa: 'In Ricerca',
  priorita: 'Alta',
  assignedTo: 'Laura Bianchi',
  dealId: null
}, {
  id: 6,
  company: 'Design Studio Milano',
  companyCategory: 'Design',
  esigenza: 'Showroom Brera',
  dettagli: '120-150 m², soffitti alti, illuminazione naturale',
  budget: '600k-800k',
  dataRichiesta: '12/01/2024',
  soluzioneProposta: '-',
  statoTrattativa: 'In Ricerca',
  priorita: 'Media',
  assignedTo: 'Giuseppe Verdi',
  dealId: null
}, {
  id: 7,
  company: 'Elite Fashion Group',
  companyCategory: 'Fashion',
  esigenza: 'Boutique Via della Spiga',
  dettagli: '110-130 m², vetrine su strada',
  budget: '850k-1.2M',
  dataRichiesta: '18/01/2024',
  soluzioneProposta: '-',
  statoTrattativa: 'In Ricerca',
  priorita: 'Alta',
  assignedTo: 'Mario Rossi',
  dealId: null
}, {
  id: 8,
  company: 'Accessories Boutique',
  companyCategory: 'Accessori',
  esigenza: 'Store Montenapoleone',
  dettagli: '70-90 m², piano terra',
  budget: '600k-750k',
  dataRichiesta: '10/01/2024',
  soluzioneProposta: '-',
  statoTrattativa: 'In Ricerca',
  priorita: 'Media',
  assignedTo: 'Laura Bianchi',
  dealId: null
}];
const stageColors: Record<string, string> = {
  Trattativa: 'bg-blue-100 text-blue-800',
  Proposta: 'bg-yellow-100 text-yellow-800',
  Chiusa: 'bg-green-100 text-green-800',
  'In Ricerca': 'bg-gray-100 text-gray-800'
};
const priorityColors: Record<string, string> = {
  Alta: 'bg-red-100 text-red-800',
  Media: 'bg-yellow-100 text-yellow-800',
  Bassa: 'bg-green-100 text-green-800'
};
export function ClientiEsigenze() {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [priorityFilter, setPriorityFilter] = useState('all');
  const navigate = useNavigate();
  const filteredEsigenze = mockEsigenze.filter(esigenza => {
    const matchesSearch = esigenza.company.toLowerCase().includes(searchTerm.toLowerCase()) || esigenza.esigenza.toLowerCase().includes(searchTerm.toLowerCase()) || esigenza.dettagli.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || esigenza.statoTrattativa === statusFilter;
    const matchesPriority = priorityFilter === 'all' || esigenza.priorita === priorityFilter;
    return matchesSearch && matchesStatus && matchesPriority;
  });
  return <div className="space-y-6" data-id="element-1114">
      <div className="flex items-center justify-between" data-id="element-1115">
        <div data-id="element-1116">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1117">
            Esigenze Clienti
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1118">
            {mockEsigenze.length} esigenze totali
          </p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-1119">
          <Plus className="w-4 h-4" data-id="element-1120" />
          Nuova Esigenza
        </button>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200 space-y-4" data-id="element-1121">
        <div className="relative" data-id="element-1122">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-1123" />
          <input type="text" placeholder="Cerca per azienda, esigenza o dettagli..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1124" />
        </div>
        <div className="flex gap-3" data-id="element-1125">
          <div className="flex-1" data-id="element-1126">
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1127">
              <option value="all" data-id="element-1128">Tutti gli stati</option>
              <option value="In Ricerca" data-id="element-1129">In Ricerca</option>
              <option value="Proposta" data-id="element-1130">Proposta</option>
              <option value="Trattativa" data-id="element-1131">Trattativa</option>
              <option value="Chiusa" data-id="element-1132">Chiusa</option>
            </select>
          </div>
          <div className="flex-1" data-id="element-1133">
            <select value={priorityFilter} onChange={e => setPriorityFilter(e.target.value)} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1134">
              <option value="all" data-id="element-1135">Tutte le priorità</option>
              <option value="Alta" data-id="element-1136">Alta</option>
              <option value="Media" data-id="element-1137">Media</option>
              <option value="Bassa" data-id="element-1138">Bassa</option>
            </select>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1139">
        <div className="overflow-x-auto" data-id="element-1140">
          <table className="w-full min-w-[1400px]" data-id="element-1141">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1142">
              <tr data-id="element-1143">
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1144">
                  Azienda
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1145">
                  Esigenza
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1146">
                  Dettagli
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1147">
                  Budget
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1148">
                  Data Richiesta
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1149">
                  Assegnato a
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1150">
                  Soluzione
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1151">
                  Trattativa
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1152">
                  Stato
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1153">
                  Priorità
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1154">
              {filteredEsigenze.map(esigenza => <tr key={esigenza.id} className="hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-1155">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1156">
                    <div data-id="element-1157">
                      <p className="text-sm font-normal text-gray-900" data-id="element-1158">
                        {esigenza.company}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-1159">
                        {esigenza.companyCategory}
                      </p>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-1160">
                    <p className="text-sm font-semibold text-gray-900" data-id="element-1161">
                      {esigenza.esigenza}
                    </p>
                  </td>
                  <td className="px-6 py-4" data-id="element-1162">
                    <p className="text-sm text-gray-600 max-w-xs" data-id="element-1163">
                      {esigenza.dettagli}
                    </p>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1164">
                    <div className="flex items-center gap-2" data-id="element-1165">
                      <Euro className="w-4 h-4 text-gray-400" data-id="element-1166" />
                      <span className="text-sm text-gray-900" data-id="element-1167">
                        {esigenza.budget}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1168">
                    <div className="flex items-center gap-2" data-id="element-1169">
                      <Calendar className="w-4 h-4 text-gray-400" data-id="element-1170" />
                      <span className="text-sm text-gray-600" data-id="element-1171">
                        {esigenza.dataRichiesta}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1172">
                    <div className="flex items-center gap-2" data-id="element-1173">
                      <div className="w-8 h-8 rounded-full bg-[#1388ad] text-white flex items-center justify-center text-xs font-medium" data-id="element-1174">
                        {esigenza.assignedTo.split(' ').map(n => n[0]).join('')}
                      </div>
                      <span className="text-sm text-gray-600" data-id="element-1175">
                        {esigenza.assignedTo}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-1176">
                    {esigenza.soluzioneProposta === '-' ? <span className="text-sm text-gray-400 italic" data-id="element-1177">
                        In ricerca
                      </span> : <button onClick={() => navigate('/properties')} className="text-sm text-[#1388ad] hover:underline" data-id="element-1178">
                        {esigenza.soluzioneProposta}
                      </button>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1179">
                    {esigenza.dealId ? <button onClick={() => navigate('/deals')} className="flex items-center gap-1 text-sm text-[#1388ad] hover:underline" data-id="element-1180">
                        <span data-id="element-1181">Trattativa #{esigenza.dealId}</span>
                        <ExternalLink className="w-3 h-3" data-id="element-1182" />
                      </button> : <span className="text-sm text-gray-400 italic" data-id="element-1183">-</span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1184">
                    <span className={`px-2 py-1 text-xs font-normal rounded-full ${stageColors[esigenza.statoTrattativa]}`} data-id="element-1185">
                      {esigenza.statoTrattativa}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1186">
                    <span className={`px-2 py-1 text-xs font-normal rounded-full ${priorityColors[esigenza.priorita]}`} data-id="element-1187">
                      {esigenza.priorita}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}